import React, { useRef } from "react";
import TablePagination from "@material-ui/core/TablePagination";
import IconButton from "@material-ui/core/IconButton";
import {
  AiOutlineStepForward,
  AiFillStepBackward,
  AiFillCaretLeft,
  AiFillCaretRight,
} from "react-icons/ai";
import { Input } from "reactstrap";

const Pagination = ({
  onRowsPerPageChange,
  count,
  page,
  onPageChange,
  rowsPerPage,
}) => {
  const isFocused = useRef(null);
  return (
    <TablePagination
      rowsPerPageOptions={[10, 20, 50, 100]}
      style={{ border: "none" }}
      ActionsComponent={CustomTablePaginationActions}
      SelectProps={{
        native: true,
      }}
      onRowsPerPageChange={onRowsPerPageChange}
      count={count}
      labelRowsPerPage="Items per page"
      labelDisplayedRows={(page) =>
        `Items ${page.from} to ${page.to === -1 ? page.count : page.to} from ${
          page.count
        }`
      }
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={rowsPerPage}
    />
  );

  function manuelPageChange(value) {
    if (+value < 1) {
      value = 1;
    }

    if (+value > Math.ceil(count / rowsPerPage)) {
      value = Math.ceil(count / rowsPerPage);
    }

    onPageChange(null, +value - 1);
  }

  function CustomTablePaginationActions(props) {
    const handleBackButtonClick = (event) => {
      props.onPageChange(event, props.page - 1);
    };

    const handleNextButtonClick = (event) => {
      props.onPageChange(event, props.page + 1);
    };

    const goToStart = (event) => {
      props.onPageChange(event, 0);
    };

    const goToEnd = (event) => {
      const endPage = Math.ceil(count / rowsPerPage) - 1;
      props.onPageChange(event, endPage);
    };

    const handleKeyDown = (event) => {
      if (event.key === "Enter" && isFocused.current) {
        handleEnterPress(event.target.value);
      }
    };
    const handleEnterPress = (value) => {
      manuelPageChange(value);
    };
    const handleBlur = ({ target: { value } }) => {
      isFocused.current = false;
      if (Number(value) !== Number(page) + 1) {
        manuelPageChange(value);
      }
    };

    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <IconButton
          onClick={goToStart}
          disabled={props.page === 0}
          aria-label="previous page"
        >
          <AiFillStepBackward />
        </IconButton>

        <IconButton
          onClick={handleBackButtonClick}
          disabled={props.page === 0}
          aria-label="previous page"
        >
          <AiFillCaretLeft />
        </IconButton>
        <Input
          style={{ width: 80, textAlign: "center" }}
          min={1}
          max={Math.ceil(count / rowsPerPage)}
          type="number"
          defaultValue={parseInt(page, 10) + 1}
          onFocus={() => (isFocused.current = true)}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
        />
        <div
          style={{ paddingLeft: 10 }}
          className="d-flex justify-content-center "
        >
          of {Math.ceil(count / rowsPerPage)}
        </div>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={
            props.page >= Math.ceil(props.count / props.rowsPerPage) - 1
          }
          aria-label="previous page"
        >
          <AiFillCaretRight />
        </IconButton>
        <IconButton
          onClick={goToEnd}
          disabled={
            props.page >= Math.ceil(props.count / props.rowsPerPage) - 1
          }
          aria-label="next page"
        >
          <AiOutlineStepForward />
        </IconButton>
      </div>
    );
  }
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.jsx